var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-nav"},[_c('div',{staticClass:"wrapper"},[_c('nav',_vm._l((_vm.pages),function(page){return _c('router-link',{key:page.path,attrs:{"to":page.path}},[_vm._v(_vm._s(page.name))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dac1002","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-nav.vue
// module id = null
// module chunks = 